import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const linkding = defineConnector({
  identifier: "linkding",
  name: "Linkding",
  tagLine: "Self-hosted bookmark manager",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Enter your Linkding details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://linkding.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Linkding instance.",
        },
      ],
    },
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Linkding, go to **Settings → Integrations** and copy your **REST API** token.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/bookmarks/`,
  },
});
